import { useMemo } from 'react';
import { Contact, DataProduct, DataVendor } from 'v2/models';
export const SortPrimaryToTop = <
  T extends { is_primary?: boolean | undefined },
>(
  arr: T[] | undefined
) => useMemo(() => arr?.sort((a) => (a.is_primary ? -1 : 0)) || [], [arr]);

export const unSelectPrimary =
  (id: number) => (a: DataProduct | DataVendor | Contact) => {
    return { ...a, is_primary: a.id === id ? false : a.is_primary };
  };

export const selectPrimary =
  (id: number) => (a: DataProduct | DataVendor | Contact) => {
    return { ...a, is_primary: a.id === id ? true : false };
  };
